"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getQueryStringValue(mapping, queryString) {
    if (mapping.value) {
        return mapping.value;
    }
    var name = mapping.key;
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(queryString);
    return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
exports.getQueryStringValue = getQueryStringValue;
function getUrlValueFromFormat(mapping, urlFormat, url) {
    if (mapping.value) {
        return mapping.value;
    }
    var name = mapping.key;
    var urlPieces = url.split('/');
    var urlFormatPieces = urlFormat.split('/');
    if (urlPieces.length === urlFormatPieces.length) {
        for (var index = 0; index < urlFormatPieces.length; index++) {
            var formatPiece = urlFormatPieces[index];
            var placeholder = "{" + name + "}";
            if (formatPiece === placeholder) {
                return urlPieces[index];
            }
        }
    }
    else {
        console.error("URL does not match provided urlFormat. URL: " + url + ", urlFormat: " + urlFormat);
    }
    return;
}
exports.getUrlValueFromFormat = getUrlValueFromFormat;
function getQueryStringAsObject(queryString) {
    // parse query string
    var params = new URLSearchParams(queryString);
    var obj = {};
    // iterate over all keys
    params.forEach(function (value, key) {
        var values = params.getAll(key);
        if (values.length > 1) {
            obj[key] = values;
        }
        else {
            obj[key] = value;
        }
    });
    return obj;
}
exports.getQueryStringAsObject = getQueryStringAsObject;
//# sourceMappingURL=url.js.map